import './LoadingOverlay.css';

import React from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useTranslation } from 'react-i18next';

interface LoadingOverlayProps {
  visible: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ visible, message }) => {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  return (
    <div className="loading-overlay" role="status" aria-live="polite">
      <div className="loading-overlay__panel">
        <ProgressSpinner
          style={{ width: '28px', height: '28px' }}
          strokeWidth="6"
          animationDuration=".8s"
        />
        <span className="loading-overlay__message">{message ?? t('loading.pleaseWait')}</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
